import React from 'react';
import {
    Show, TabbedShowLayout, Tab,  Datagrid,
    TextField, DateField, ReferenceManyField, Pagination,
} from 'react-admin';
import { ColoredBooleanField } from '../../components/fields';
import Title from './Title';

import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/showStyles';

const ShowPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250]} {...props} />;

const MultiDistrictsShow = withStyles(styles)(({ classes,...props }) => (
    <Show title={<Title />} {...props}>
        <TabbedShowLayout>
            <Tab
                label='resources.multidistricts.tabs.details'
            >
                <ColoredBooleanField
                    source='Active'
                />
                <DateField
                    source='CreateDate'
                    showTime
                    className={classes.inlineBlock}
                />
                <DateField
                    source='ModifiedDate'
                    showTime
                    className={classes.inlineBlock}
                />
            </Tab>
            <Tab
                label='resources.multidistricts.tabs.districts'
                path='districts'
            >
                <ReferenceManyField
                    reference='districts'
                    target='MultiDistrictID'
                    sort={{ field: 'DistrictName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='DistrictName'
                        />
                        <TextField
                            source='PartnerName'
                            headerClassName={classes.partnerName}
                            cellClassName={classes.partnerName}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
            <Tab
                label='resources.multidistricts.tabs.clubs'
                path='clubs'
            >
                <ReferenceManyField
                    reference='clubs'
                    target='MultiDistrictID'
                    sort={{ field: 'ClubName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='ClubName'
                        />
                        <TextField
                            source='DistrictName'
                            headerClassName={classes.districtName}
                            cellClassName={classes.districtName}
                        />
                        <TextField
                            source='StateCode'
                            headerClassName={classes.stateCode}
                            cellClassName={classes.stateCode}
                        />
                        <TextField
                            source='CountryCode'
                            headerClassName={classes.countryCode}
                            cellClassName={classes.countryCode}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
            <Tab
                label='resources.multidistricts.tabs.members'
                path='members'
            >
                <ReferenceManyField
                    reference='members'
                    target='MultiDistrictID'
                    sort={{ field: 'LastName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='LastName'
                            headerClassName={classes.lastName}
                            cellClassName={classes.lastName}
                        />
                        <TextField
                            source='FirstName'
                            headerClassName={classes.firstName}
                            cellClassName={classes.firstName}
                        />
                        <TextField
                            source='Email'
                            headerClassName={classes.email}
                            cellClassName={classes.email}
                        />
                        <TextField
                            source='ClubName'
                            headerClassName={classes.clubName}
                            cellClassName={classes.clubName}
                        />
                        <TextField
                            source='DistrictName'
                            headerClassName={classes.districtName}
                            cellClassName={classes.districtName}
                        />
                        <TextField
                            source='StateCode'
                            headerClassName={classes.stateCode}
                            cellClassName={classes.stateCode}
                        />
                        <TextField
                            source='CountryCode'
                            headerClassName={classes.countryCode}
                            cellClassName={classes.countryCode}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
));
export default MultiDistrictsShow;